__turbopack_context__.v({
  "carousel": "instructor-testimonials-module-scss-module__tuftXW__carousel",
  "dot": "instructor-testimonials-module-scss-module__tuftXW__dot",
  "dots": "instructor-testimonials-module-scss-module__tuftXW__dots",
  "heading": "instructor-testimonials-module-scss-module__tuftXW__heading",
  "heading-highlight": "instructor-testimonials-module-scss-module__tuftXW__heading-highlight",
  "inner": "instructor-testimonials-module-scss-module__tuftXW__inner",
  "pager": "instructor-testimonials-module-scss-module__tuftXW__pager",
  "pager-button": "instructor-testimonials-module-scss-module__tuftXW__pager-button",
  "slide": "instructor-testimonials-module-scss-module__tuftXW__slide",
  "testimonials": "instructor-testimonials-module-scss-module__tuftXW__testimonials",
  "track": "instructor-testimonials-module-scss-module__tuftXW__track",
});
